import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import Slider from '../components/slider/Slider';
import { MD } from '../global_vars';
import GFade from '../components/gfade/GFade';
// @ts-ignore

@Component({
  components: {
    Slider,
    GFade,
  }
})
export default class VMAbout extends Vue {
  mounted(): void {
    if (MD.mobile()) return;
    // animateText(<HTMLElement>this.$refs.title).then();
  }
}
